<template>
  <v-card>
    <v-card-title>
      Profile Details
    </v-card-title>
    <v-card-subtitle>
      Change your profile info at any time
    </v-card-subtitle>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="profile.firstName"
              label="First name"
              outlined
              maxlength="50"
              :rules="[$rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="profile.lastName"
              label="Last name"
              outlined
              maxlength="50"
              :rules="[$rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="profile.email"
              label="Email"
              outlined
              maxlength="100"
              :rules="[$rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="profile.phoneNumber"
              label="Phone"
              outlined
              :rules="[$rules.phone]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="profile.jobTitle"
              label="Job title"
              outlined
              maxlength="50"
              :rules="[$rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            :sm="
              field.customField.typeId == $enums.customFieldTypes.LARGE_TEXT
                ? 12
                : 6
            "
            :md="
              field.customField.typeId == $enums.customFieldTypes.LARGE_TEXT
                ? 12
                : 4
            "
            v-for="(field, i) in profile.customFields"
            :key="i"
          >
            <v-text-field
              v-model="field.value"
              outlined
              :label="field.customField.name"
              :required="field.customField.isRequired"
              :rules="field.customField.isRequired ? [$rules.required] : []"
              v-if="field.customField.typeId == $enums.customFieldTypes.TEXT"
            ></v-text-field>
            <v-menu
              v-model="field.menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              v-else-if="
                field.customField.typeId == $enums.customFieldTypes.DATE
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formattedDate(field.value)"
                  outlined
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :label="field.customField.name"
                  @click:clear="field.value = null"
                  append-icon="today"
                  @click:append="field.menu = true"
                  :rules="field.customField.isRequired ? [$rules.required] : []"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="field.value"
                @input="field.menu = false"
              ></v-date-picker>
            </v-menu>
            <v-textarea
              v-else-if="
                field.customField.typeId == $enums.customFieldTypes.LARGE_TEXT
              "
              outlined
              v-model="field.value"
              :label="field.customField.name"
              :rules="field.customField.isRequired ? [$rules.required] : []"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" :loading="saving">Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "UserProfileForm",
  props: { loading: { type: Boolean, default: false } },
  data: () => ({
    valid: true,
    saving: false
  }),
  watch: {
    profile(val, old) {
      if (this._.isEmpty(old) && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  computed: {
    formattedDate() {
      return date => {
        if (date) {
          return moment(date).format("MM/DD/YYYY");
        }
        return "";
      };
    },
    ...mapGetters({
      profile: "profile/profile",
      custom_fields: "company/custom_fields"
    })
  },
  created() {
    this.profile.customFields = this.profile.customFields || [];

    let currentIds = this.profile.customFields.map(x => x.customField.id);

    let fieldsToAdd = this.custom_fields.filter(
      x => !currentIds.includes(x.id)
    );

    let self = this;
    this.profile.customFields = this._.sortBy(
      this.profile.customFields.concat(
        fieldsToAdd.map(x => ({ value: "", customField: x }))
      ),
      function(o) {
        return o.customField.typeId == self.$enums.customFieldTypes.LARGE_TEXT;
      }
    );
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("profile/saveProfile", this.profile)
          .then(() => {
            this.$root.$snackbarSuccess("Profile saved.");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your profile."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
